import React, { useState } from 'react';

const Login = ({ onLogin, onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background pitch-stripes flex flex-col items-center justify-center p-4 relative overflow-hidden">
      
      {onClose && (
        <button
          onClick={onClose}
          className="absolute top-6 right-6 z-20 p-3 bg-surface-container border border-outline-variant/50 rounded-xl text-stone-600 hover:text-on-background hover:bg-surface-container-high transition-all active:scale-95"
        >
          <span className="material-symbols-outlined">close</span>
        </button>
      )}
      
      {/* Center-circle motif, like the kickoff circle on a pitch */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[560px] h-[560px] rounded-full border-2 border-primary/10 pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[380px] h-[380px] rounded-full border-2 border-primary/10 pointer-events-none"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[560px] h-[2px] bg-primary/10 pointer-events-none"></div>

      <div className="w-full max-w-md relative z-10">
        {/* Logo Section */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-surface-container border border-outline-variant/50 rounded-3xl mb-6 shadow-xl relative group">
            <div className="absolute inset-0 bg-primary/10 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <span className="material-symbols-outlined text-5xl text-primary">sports_soccer</span>
          </div>
          <h1 className="text-4xl font-black font-lexend tracking-tight mb-2" style={{ letterSpacing: '0.02em' }}>ECLIPSE FC</h1>
          <p className="font-manrope text-stone-700 font-bold uppercase tracking-widest text-sm">Squad Login</p>
        </div>

        {/* Login Card */}
        <div className="bg-surface-container border border-outline-variant/50 rounded-3xl p-8 shadow-xl">
          {error && (
            <div className="mb-6 bg-error/10 border border-error/20 flex items-center gap-3 px-4 py-3 rounded-xl animate-fadeIn">
              <span className="material-symbols-outlined text-error text-xl">error</span>
              <p className="text-error font-manrope text-sm font-bold">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Username Field */}
            <div className="space-y-2">
              <label className="block text-stone-700 font-manrope text-[11px] font-bold uppercase tracking-widest pl-1">
                Username
              </label>
              <div className="relative group">
                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-stone-600 group-focus-within:text-primary transition-colors">person</span>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter your username"
                  className="w-full bg-background border border-outline-variant/70 rounded-xl pl-12 pr-4 py-4 text-on-background font-manrope placeholder:text-stone-600 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                  required
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="space-y-2">
              <label className="block text-stone-700 font-manrope text-[11px] font-bold uppercase tracking-widest pl-1">
                Password
              </label>
              <div className="relative group">
                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-stone-600 group-focus-within:text-primary transition-colors">lock</span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full bg-background border border-outline-variant/70 rounded-xl pl-12 pr-4 py-4 text-on-background font-manrope placeholder:text-stone-600 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-all"
                  required
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full mt-8 bg-primary hover:bg-primary/90 text-on-primary font-lexend font-bold uppercase tracking-widest py-4 rounded-xl transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <span className="material-symbols-outlined animate-spin text-xl">progress_activity</span>
                  Signing in...
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined text-xl">sports_soccer</span>
                  Kick Off
                </>
              )}
            </button>
          </form>
        </div>

        {/* Footer */}
        <div className="text-center mt-8 space-y-2">
          <p className="text-stone-700 font-manrope text-xs font-bold flex items-center justify-center gap-1.5">
            <span className="material-symbols-outlined text-[14px]">shield</span>
            Secure Connection
          </p>
          <p className="text-stone-600 font-manrope text-[10px] uppercase tracking-widest">
            Eclipse FC • Match Tracker
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
